var UserAPI = require("../../common/api/user");

module.exports = function ($scope, $state, $stateParams, $location) {
    var vm = this;
    vm.location = $location.absUrl();
    vm.profile = {};
    vm.supported = [];

    $scope.init = function () {
        vm.loading = true;
        UserAPI.GetProfileByReference($stateParams.fundraiserRef, "UserProfileLabelView").then(function (result) {
            var fundraiserId = result.id;
            UserAPI.GetFundraiserProfile(fundraiserId, "FundraiserApplicationSummaryView").then(function (result) {
                vm.supported = result;
                vm.supported.forEach(function (item) {
                    var perc = Math.floor((item.grandTotalRaised * 100) / (item.totalRequested + item.totalExternallyRaised));
                    if (perc <= 0) {
                        item.percentage = 0;
                    } else {
                        item.percentage = perc;
                    }
                });
            });

            UserAPI.GetProfile(result.id, 'UserPublicProfileView').then(function (result) {
                vm.loading = false;
                vm.profile = result;
                if (vm.profile.profilePicture) {
                    var formattedId = (vm.profile.profilePicture.blobId).replace(/-/g, '');
                    vm.profile.profilePictureUrl = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent(formattedId) + "/" + vm.profile.profilePicture.fileName)
                }
            });
        });
    };


    $scope.init();
}
